module.exports = __webpack_public_path__ + "static/media/3-iron.594c6a78.png";